import { NetworkBackground } from "@civala/shared-ui"
import { ActionIcon, Anchor, Box, Group, Tooltip, useComputedColorScheme, useMantineColorScheme } from "@mantine/core"
import { IconArrowLeft, IconMoon, IconSun } from "@tabler/icons-react"
import { createFileRoute } from "@tanstack/react-router"

import { Podcasts } from "@/pages/Podcasts"

export const Route = createFileRoute("/podcasts")({
  component: PodcastsRoute,
})

function PodcastsRoute() {
  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme("light")
  const isDark = computedColorScheme === "dark"

  return (
    <Box style={{ position: "relative", minHeight: "100vh", overflow: "hidden" }}>
      <NetworkBackground />

      {/* Top bar with back link and theme toggle */}
      <Box style={{ position: "absolute", top: 20, left: 20, right: 20, zIndex: 10 }}>
        <Group justify="space-between">
          <Anchor href="/" c="dimmed" size="sm" underline="hover">
            <Group gap={4}>
              <IconArrowLeft size={16} />
              Back to Civala AI
            </Group>
          </Anchor>
          <Tooltip label={isDark ? "Light mode" : "Dark mode"}>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="lg"
              aria-label="Toggle color scheme"
              onClick={() => setColorScheme(isDark ? "light" : "dark")}
            >
              {isDark ? <IconSun size={20} stroke={1.5} /> : <IconMoon size={20} stroke={1.5} />}
            </ActionIcon>
          </Tooltip>
        </Group>
      </Box>

      <Box pt={60}>
        <Podcasts />
      </Box>
    </Box>
  )
}
